<template>
  <b-card no-body class="info-card">
    <b-card-header class="info-header">
      <div class="header-title">
        <i class="fas fa-info-circle mr-2"></i>
        <strong>Informações</strong>
      </div>
      <div class="header-info">
        O requerente visualizou o andamento desta ouvidoria
        {{ ombudsman.protocolViewCount || 0 }}
        {{ ombudsman.protocolViewCount === 1 ? "vez" : "vezes" }}.
        <span v-if="ombudsman.protocolLastView"
          >Última visualização
          {{ ombudsman.protocolLastView | datetime }}.</span
        >
      </div>
    </b-card-header>
    <b-card-body class="info-body">
      <fieldset class="pb-3">
        <legend hidden>Informações da Ouvidoria</legend>
        <b-row>
          <b-col cols="6">
            <h5>
              Protocolo: <strong>{{ ombudsman.protocol }}</strong>
            </h5>
          </b-col>
          <b-col cols="6">
            <h5>
              Status:
              <b-badge :variant="getBadgeColor(ombudsman.status)">{{
                getStatusText(ombudsman.status)
              }}</b-badge>
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <h5>Data de Recebimento: {{ ombudsman.createdAt | datetime }}</h5>
          </b-col>
          <b-col cols="6">
            <h5>Última Movimentação: {{ ombudsman.updatedAt | datetime }}</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <h5>Portal de Recebimento: /{{ ombudsman.portal.slug }}</h5>
          </b-col>
          <b-col cols="6">
            <h5>Prazo: {{ getDeadline(ombudsman) | datetime }}</h5>
          </b-col>
        </b-row>
      </fieldset>
      <fieldset class="pb-3">
        <legend>Requerente</legend>
        <b-row>
          <b-col cols="4">
            <label>Nome:</label>
            {{ ombudsman.person.fullName | noInformation }}
          </b-col>
          <b-col cols="4">
            <label>CPF:</label>
            {{ ombudsman.person.cpf | noInformation }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <label>Telefone:</label>
            {{ ombudsman.person.phone | noInformation }}
          </b-col>
          <b-col cols="4">
            <label>Email:</label>
            {{ ombudsman.person.email | noInformation }}
          </b-col>
        </b-row>
      </fieldset>
      <b-row class="pb-3">
        <b-col md="12">
          <h5>Descrição</h5>
          <div>{{ ombudsman.text }}</div>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="12">
          <h5>Informação relacionada</h5>
          <div>{{ ombudsman.relatedInfo }}</div>
        </b-col>
      </b-row>
      <template v-if="ombudsman.submittedClassification">
        <hr class="hr-text" data-content="Indicadores informados" />
        <template v-for="opt in Object.values(ClassificationTypeMap)">
          <div v-if="ombudsman.submittedClassification[opt]" :key="opt">
            <b>{{ ClassificationName[opt] }}:</b>
            {{ classificationMaps[opt][ombudsman.submittedClassification[opt]]
            }}<br />
          </div>
        </template>
        <template v-for="group in classificationGroups">
          <div
            v-if="ombudsman.submittedClassification[`custom_${group._id}`]"
            :key="group._id"
          >
            <b>{{ group.name }}:</b>
            {{
              group.options.find(
                (opt) =>
                  opt._id ===
                  ombudsman.submittedClassification[`custom_${group._id}`]
              ).value
            }}
            <br />
          </div>
        </template>
        <hr class="hr-text" />
      </template>
      <b-button
        variant="link"
        class="float-right"
        @click="fullView = !fullView"
      >
        <template v-if="fullView"
          >Comprimir <i class="fas fa-minus" aria-hidden="true"></i
        ></template>
        <template v-else
          >Expandir <i class="fas fa-plus" aria-hidden="true"></i
        ></template>
      </b-button>
      <b-collapse id="ombudsman-info" v-model="fullView">
        <b-row v-if="ombudsman.files.length > 0">
          <b-col md="12">
            <h5>Anexos</h5>
            <b-list-group>
              <b-list-group-item
                v-for="(file, idx) in ombudsman.files"
                :key="idx"
                class="d-flex justify-content-between align-items-center"
              >
                {{ file.name }}
                <b-button @click="$emit('download-file', file)">
                  <i class="fa fa-download" aria-hidden="true"></i>
                </b-button>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card-body>
  </b-card>
</template>

<script>
import { getBadgeColor, getStatusText } from "../../complaints/utils";
import { getDeadline } from "../ombudsman-utils";
import {
  ClassificationTypeMap,
  ClassificationName,
} from "../../../../../backend/models/ClassificationType.ts";

export default {
  name: "InfoCard",
  props: {
    ombudsman: {
      type: Object,
      required: true,
    },
    classificationMaps: {
      type: Object,
      required: true,
    },
    classificationGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fullView: false,
      ClassificationTypeMap,
      ClassificationName,
    };
  },
  methods: {
    getBadgeColor,
    getStatusText,
    getDeadline,
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
